<template>
  <div>
    <h2>题库记录</h2>
    <el-table :data="tableData" border style="width: 100%" v-loading="loading">
      <el-table-column prop="id" label="ID" width="80"></el-table-column>
      <el-table-column prop="content" label="题目内容"></el-table-column>
      <el-table-column prop="answer" label="标准答案"></el-table-column>
      <el-table-column prop="type" label="类型" width="100"></el-table-column>
      <el-table-column prop="tag" label="标签"></el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import api from '@/api'
export default {
  data() { return { tableData: [], loading: false } },
  created() { this.fetchData() },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await api.getQuestionRecords({skip:0, limit:100});
        this.tableData = res.items || [];
      } catch (e) { console.error(e) }
      finally { this.loading = false; }
    }
  }
}
</script>